var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselBg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 744,
    height: 612,
    viewBox: "0 0 744 612",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 712,
    height: 580
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 712,
    height: 580,
    rx: 32,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-403.626 362.074 102.317-7.688c125.353 126.72 233.653 155.138 324.9 85.252 87.502-60.629 208.565-55.316 363.191 15.938 73.993 35.836 161.245 54.222 261.754 55.159 109.027-5.41 192.848 3.228 251.464 25.913 119.68 66 242.29 49.602 367.84-49.194L1390 405.238l131.91-754.379-1743.687-316.576-181.849 1027.791z",
    fill: "#41BA48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-353.621 570.046c77.816-10.848 168.625-32.98 271.192-98.028 153.85-97.572 346.505-150.331 678.955.013 163.444 66.897 278.568 40.746 346.607-46.821a2599659.16 2599659.16 0 0 1 125.297-143.14 34395859.3 34395859.3 0 0 0-20.48-677.767l-1431.387 37.03 29.816 928.713z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-455.666 783.485c261.201-321.671 473.541-529.019 637.022-622.044 78.156-55.007 181.422-62.394 309.799-22.161 186.84 50.655 352.994-13.841 498.462-193.485 241.823-336.772 514.543-487.221 818.143-451.35l-1.4-143.446-2310.198-8.329-2.143 1495.972 50.315-55.157z",
    fill: "url(#c)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m282.238 172.407-3.892-5.755-3.071 6.251 6.963-.496zM467.867 166.21l-3.248 14.395-10.776-10.031 14.024-4.364zM444.737 88.936l2.465 8.279-8.433-1.972 5.968-6.307zM290.574 84.251l8.497 1.547-5.572 6.63-2.925-8.177zM240.928 136.57l4.821-1.95-.729 5.145-4.092-3.195zM500.5 104.748l2.276 4.669-5.183-.36 2.907-4.309zM378.547 67.447l-8.196 2.826 1.664-8.499 6.532 5.673z",
    fill: "#fff",
    fillOpacity: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 546.957,
    y1: 214.469,
    x2: 98.535,
    y2: 370.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53BF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1166.32,
    y1: -101.531,
    x2: -121.023,
    y2: 122.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A1D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselBg1);
export default __webpack_public_path__ + "static/media/carouselBg1.1131e9d8ece42354a9d58d5c267abe78.svg";
export { ForwardRef as ReactComponent };